export const en_wallet = {
  main: "Token rewards for both creators and users.",
  sub1: "Ubiq creators can earn token rewards based on the number of views without any hurdles.",
  sub2: "At the same time, ordinary users can also earn token rewards for ad views simply by viewing ads.",
  sub3: "The accumulated tokens are collected in your own Ubiq wallet and can be exchanged for Amazon gift certificates, transferred to your own bank account, or used for chipping creators or purchasing paid content (currently under development)."
}